import React, { useState, useEffect } from 'react';
import Collection from 'components/Collection';
import optimizely, { optimizelyFeatures } from 'api/optimizely';
import { isEmpty } from 'util/index';
import { TILE_COMPONENT_TYPES } from 'components/TileComponent/TileComponent.const';
import { TILE_SIZES } from 'globalConst/const';

interface RecentlyPlayedStationsCollectionProps {
  history: string[];
  contentTypeId: string;
  slug: string;
  display: string;
  recentSearch: boolean;
}

const RecentlyPlayedStationsCollection = (props: RecentlyPlayedStationsCollectionProps): JSX.Element => {
  const { history = [], contentTypeId, slug, display } = props;
  /**
   * Optimizely experiment
   * ZERO - Do not show tiles
   * ONE - Show one tile
   * TWO - Show two or more tiles
   */

  const [stations, setStations] = useState([]);

  useEffect(() => {
    const numberOfTiles = optimizely.getFeatureVariable(optimizelyFeatures.RECENTLY_PLAYED_TILES, 'variant');
    let items;

    if (numberOfTiles === 'TWO' && history.length >= 2) {
      items = history;
    } else if (numberOfTiles === 'ONE') {
      items = history.slice(0, 1);
    }

    if (!isEmpty(items)) {
      setStations(items.map((slug) => ({ contentTypeId: 'station', slug })));
    }
  }, [history]);

  if (isEmpty(stations)) {
    return null;
  }

  return (
    <Collection
      uuid={`collection-id-${contentTypeId}`}
      tileComponent={TILE_COMPONENT_TYPES.RECENTLY_PLAYED_STATION}
      contentTypeId={contentTypeId}
      slug={slug}
      items={stations}
      title={''}
      mobileRows={1}
      rows={1}
      display={display}
      tileSizes={TILE_SIZES.SMALL}
    />
  );
};

export default RecentlyPlayedStationsCollection;
